import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { useFormRCAutoDetails } from "../rcautoContext";
import { useMemo } from "react";

const ConfermaSalva = ({ open, setOpen, onConfirm, onModifica }) => {
  const theme = useTheme();
  const { formState } = useFormRCAutoDetails();

  const isPiva = Object.keys(formState.legale).length > 0;
  const { cliente } = formState;

  const validation = useMemo(() => {
    if (!cliente) return { hasAddress: false, hasContacts: false };

    // Check address fields: slResIndirizzoVia, slResIndirizzo, slResCap, slResCivico
    const hasAddress =
      cliente.slResIndirizzoVia &&
      cliente.slResIndirizzo &&
      cliente.slResCap &&
      cliente.slResCivico;

    // Check contacts: idTipologia 3 (Cellulare) and 1 (Email) both predefinito = 1
    const hasCell = cliente.contatti?.some(
      (c) => c.idTipologia === 3 && c.predefinito === 1 && c.valore,
    );
    const hasEmail = cliente.contatti?.some(
      (c) => c.idTipologia === 1 && c.predefinito === 1 && c.valore,
    );

    return {
      hasAddress: !!hasAddress,
      hasContacts: !!(hasCell && hasEmail),
      cellMissing: !hasCell,
      emailMissing: !hasEmail,
    };
  }, [cliente]);

  const canProceed = validation.hasAddress && validation.hasContacts;

  const handleClose = () => setOpen(false);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
          },
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>
        Salva preventivo
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Si sta procedendo a salvare il preventivo.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          Prima di procedere verificare la correttezza di questi dati:
        </Typography>

        <Box sx={{ pl: 2, mb: 2 }}>
          <Typography
            variant="body1"
            sx={{
              color: validation.hasAddress ? "success.main" : "error.main",
              fontWeight: 500,
            }}
          >
            • {isPiva ? "Sede legale" : "Indirizzo"}:{" "}
            {validation.hasAddress
              ? `${cliente.slResIndirizzoVia} ${cliente.slResIndirizzo}, ${cliente.slResCivico} - ${cliente.slResCap}`
              : "Indirizzo mancante"}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: validation.hasContacts ? "success.main" : "error.main",
              fontWeight: 500,
              mt: 1,
            }}
          >
            • Email:{" "}
            {validation.hasContacts
              ? cliente.contatti.find(
                  (el) => el.idTipologia === 3 && el.predefinito === 1,
                ).valore
              : "integrare informazione"}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: validation.hasContacts ? "success.main" : "error.main",
              fontWeight: 500,
              mt: 1,
            }}
          >
            • Cellulare:{" "}
            {validation.hasContacts
              ? cliente.contatti.find(
                  (el) => el.idTipologia === 1 && el.predefinito === 1,
                ).valore
              : "integrare informazione"}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={handleClose} color="inherit" variant="outlined">
          Chiudi
        </Button>
        <Button
          onClick={onModifica}
          color="primary"
          variant="outlined"
          sx={{ mx: 2 }}
        >
          Modifica dati
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={!canProceed} //Richiama la funzione che salva tutti i dati, poi l'api che salva il preventivo
        >
          Procedi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfermaSalva;
